import React from 'react';

const StatCardSkeleton: React.FC = () => {
  return (
    <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-sm p-6 border border-gray-100 dark:border-gray-700 relative overflow-hidden">
      <div className="flex items-start justify-between mb-4">
        <div className="w-12 h-12 rounded-xl bg-gray-200 dark:bg-gray-700 shimmer"></div>
        <div className="flex items-center gap-2">
          <div className="w-14 h-6 bg-gray-200 dark:bg-gray-700 rounded-full shimmer"></div>
          <div className="w-14 h-6 bg-gray-200 dark:bg-gray-700 rounded-full shimmer"></div>
        </div>
      </div>
      <div className="h-6 bg-gray-200 dark:bg-gray-700 rounded w-3/4 mb-2 shimmer"></div>
      <div className="h-10 bg-gray-200 dark:bg-gray-700 rounded w-1/2 mb-1 shimmer"></div>
      <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded w-1/3 mt-2 shimmer"></div>

      <style>{`
        @keyframes shimmer {
          0% {
            background-position: -1000px 0;
          }
          100% {
            background-position: 1000px 0;
          }
        }
        
        .shimmer {
          background: linear-gradient(
            90deg,
            #f0f0f0 0%,
            #e0e0e0 20%,
            #f0f0f0 40%,
            #f0f0f0 100%
          );
          background-size: 1000px 100%;
          animation: shimmer 2s infinite linear;
        }
        
        .dark .shimmer {
          background: linear-gradient(
            90deg,
            #374151 0%,
            #4b5563 20%,
            #374151 40%,
            #374151 100%
          );
          background-size: 1000px 100%;
          animation: shimmer 2s infinite linear;
        }
      `}</style>
    </div>
  );
};

export default StatCardSkeleton;

